<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full xs:w-full sm:w-full md:w-1/4">
      <v-card class="mx-3">
        <p class="p-5 text-center text-zt-xl text-zt-primary-200 font-medium">
          {{ $t('message.searchComponent.search') }}
        </p>
        <hr />
        <form
          @keyup.enter.prevent="searchEmployees(limit, page, sort)"
          data-vs-form="search-employees"
        >
          <div class="mx-4 mb-2">
            <p class="mt-2 text-zt-sm text-zt-primary-200">
              {{ $t('message.searchComponent.search_text_1') }}
            </p>
            <zt-input
              class="mt-3 px-2 w-full"
              v-model="search.user"
              :label="$t('message.searchComponent.search_text_1_1')"
              data-vs-input="search-user"
            />
            <zt-input
              class="mt-4 px-2 w-full"
              v-model="search.legajo"
              :label="$t('message.searchComponent.search_text_1_2')"
              data-vs-input="search-legajo"
            />
            <div
              class="form__advanced flex justify-end text-right mt-3 text-zt-secondary-200 pb-3 cursor-pointer"
              @click="advanced_search = !advanced_search"
              data-vs-button="advanced-search"
            >
              <p class="text__advancedSearch">
                {{ $t('message.searchComponent.search_text_1_3') }}
              </p>
              <svg
                class="ml-1"
                :class="[advanced_search ? 'm-form__advanced--arrowDown' : '']"
                width="10"
                height="10"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.46465 4.59896L7.87134 4.20258C8.04354 4.03474 8.04354 3.76334 7.87134 3.59729L4.31191 0.126245C4.13971 -0.0415931 3.86126 -0.0415931 3.69089 0.126245L0.129639 3.59729C-0.0425619 3.76512 -0.0425619 4.03652 0.129639 4.20258L0.536325 4.59896C0.710358 4.76858 0.994305 4.76501 1.16467 4.59182L3.26772 2.44027V7.57184C3.26772 7.80932 3.46374 8.00037 3.70738 8.00037H4.2936C4.53724 8.00037 4.73326 7.80932 4.73326 7.57184V2.44027L6.8363 4.59182C7.00667 4.7668 7.29062 4.77037 7.46465 4.59896Z"
                  fill="#E4527F"
                />
              </svg>
            </div>
            <p class="text-zt-sm text-zt-primary-200 mb-2">
              {{ $t('message.searchComponent.search_text_2') }}
            </p>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  :value="search.estatus.onBoarding"
                  v-model="search.checkedEstatus"
                  type="checkbox"
                  data-vs-checkbox="search-status"
                />
                {{ $t('message.searchComponent.search_text_2_1') }}
                <span></span>
              </label>
            </div>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  :value="search.estatus.activo"
                  v-model="search.checkedEstatus"
                  type="checkbox"
                  data-vs-checkbox="search-status-active"
                />
                {{ $t('message.searchComponent.search_text_2_2') }}
                <span></span>
              </label>
            </div>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  :value="search.estatus.inactivo"
                  v-model="search.checkedEstatus"
                  type="checkbox"
                  data-vs-checkbox="search-status-inactive"
                />
                {{ $t('message.searchComponent.search_text_2_3') }}
                <span></span>
              </label>
            </div>
            <p class="text-zt-sm text-zt-primary-200 mb-2">
              {{ $t('message.searchComponent.search_text_7') }}
            </p>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  v-model="search.primer_login.active"
                  type="checkbox"
                  data-vs-checkbox="search-first-login"
                />
                {{ $t('message.searchComponent.search_text_7_1') }}
                <span></span>
              </label>
            </div>
          </div>
          <div class="advanced_search mx-4 mb-2" v-show="advanced_search">
            <p class="text-zt-sm text-zt-primary-200 mb-2">
              {{ $t('message.searchComponent.search_text_3') }}
            </p>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  type="checkbox"
                  :value="search.rrhh.value"
                  :disabled="
                    search.checkedTipoPerfil.length >= 1 &&
                      search.checkedTipoPerfil.indexOf(search.rrhh.value) == -1
                  "
                  v-model="search.checkedTipoPerfil"
                  data-vs-checkbox="search-rrhh"
                />
                {{ $t('message.searchComponent.search_text_3_1') }}
                <span></span>
              </label>
            </div>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  type="checkbox"
                  :value="search.empleado.value"
                  :disabled="
                    search.checkedTipoPerfil.length >= 1 &&
                      search.checkedTipoPerfil.indexOf(search.empleado.value) ==
                        -1
                  "
                  v-model="search.checkedTipoPerfil"
                  data-vs-checkbox="search-employee"
                />
                {{ $t('message.searchComponent.search_text_3_2') }}
                <span></span>
              </label>
            </div>
            <div class="pt-2" v-if="search.esRRRHHSector == false">
              <p class="mt-2 text-zt-sm text-zt-primary-200">
                {{ $t('message.searchComponent.advanceSearch.text_sector') }}
              </p>
              <multiselect
                v-model="search.sector.value"
                :options="search.sector.data"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                data-vs-multiselect="search-sector"
              >
              </multiselect>
            </div>
            <div class="pt-2" v-if="search.esRRRHHSector == false">
              <p class="mt-2 text-zt-sm text-zt-primary-200">
                {{ $t('message.searchComponent.advanceSearch.text_locacion') }}
              </p>
              <multiselect
                v-model="search.locacion.value"
                :options="search.locacion.data"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                data-vs-multiselect="search-location"
              >
              </multiselect>
            </div>
            <div class="flex pt-2">
              <div class="w-full">
                <p
                  class="text-zt-sm text-zt-primary-200 mb-2 pt-2 inline-block"
                >
                  {{
                    $t('message.searchComponent.position_position_ubication')
                  }}
                </p>
                <zt-tooltip
                  :text="
                    $t('message.searchComponent.listEmployees.tooltip_cargo')
                  "
                  position="right"
                  color="primary"
                  class="inline-block"
                >
                  <zt-icon name="info-circle-alt text-zt-lg cursor-pointer" />
                </zt-tooltip>
                <multiselect
                  v-model="search.cargo.value"
                  class="mb-2"
                  name="cargo"
                  :options="search.cargo.data"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="$t('message.searchComponent.select_position')"
                  data-vs-multiselect="search-position"
                >
                  <template slot="noResult"
                    ><span class="multiselect__single">{{
                      $t('message.searchComponent.error_position_not_found')
                    }}</span></template
                  >
                  <template slot="noOptions"
                    ><span class="multiselect__single">{{
                      $t('message.searchComponent.empty_list')
                    }}</span></template
                  >
                </multiselect>
              </div>
              <div
                v-if="search.cargo.value.length !== 0"
                @click="clearPosition()"
                class="cursor-pointer align-items-end d-flex mt-6"
                data-vs-button="search-cargo"
              >
                <zt-icon name="times" />
              </div>
            </div>
            <div class="flex">
              <div class="w-full">
                <p class="text-zt-sm text-zt-primary-200 mb-2 inline-block">
                  {{
                    $t('message.searchComponent.report_to_position_ubication')
                  }}
                </p>
                <zt-tooltip
                  :text="
                    $t('message.searchComponent.listEmployees.tooltip_report')
                  "
                  position="right"
                  color="primary"
                  class="inline-block"
                >
                  <zt-icon name="info-circle-alt text-zt-lg cursor-pointer" />
                </zt-tooltip>
                <multiselect
                  @search-change="searchingEmployees"
                  v-model="search.report.value"
                  class="mb-2"
                  :options="search.report.datos"
                  :searchable="true"
                  label="name"
                  id="reporta_a"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :loading="isLoading"
                  :preserve-search="true"
                  :tag-placeholder="$t('message.searchComponent.form_select')"
                  :show-labels="false"
                  :placeholder="
                    $t('message.searchComponent.search_combo_reporta_a')
                  "
                  data-vs-multiselect="search-employees"
                >
                  <template slot="noResult"
                    ><span class="multiselect__single">{{
                      $t('message.searchComponent.not_founded')
                    }}</span></template
                  >
                  <template slot="noOptions"
                    ><span class="multiselect__single">{{
                      $t('message.searchComponent.empty_list')
                    }}</span></template
                  >
                  <template slot="maxElements"
                    ><span class="multiselect__single">{{
                      $t('message.searchComponent.max_elements')
                    }}</span></template
                  >
                </multiselect>
              </div>
              <div
                v-if="search.report.value.length !== 0"
                @click="clearReport()"
                class="cursor-pointer align-items-end d-flex mt-6"
                data-vs-button="search-clear"
              >
                <zt-icon name="times" />
              </div>
            </div>
            <div v-if="search.esRRRHHSector" class="mt-3">
              <v-select
                v-model="selectedItem"
                :label="$t('message.searchComponent.search_text_8')"
                item-value="id"
                item-text="value"
                :items="search.sectorLocacion.valueClosedArr"
                return-object
                @change="openChip(selectedItem)"
                ref="selectFilter"
                data-vs-select="search-sector-location"
              ></v-select>
              <div
                v-for="(item, index) in search.sectorLocacion.locationChipsArr"
                :key="item.id"
              >
                <zt-chip
                  @click:close="closeChip(item, index)"
                  color="primary"
                  outline
                  closable
                  :data-vs-chip="`chip-${index}`"
                >
                  <div
                    style="
                      max-width: 168px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                    v-bind:title="item.value"
                  >
                    {{ item.value }}
                  </div>
                </zt-chip>
              </div>
            </div>

            <div>
              <p class="text-zt-sm text-zt-primary-200 mt-2 mb-2">
                {{ $t('message.searchComponent.search_text_10') }}
              </p>
              <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="258px"
                min-width="258px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :placeholder="
                      $t('message.searchComponent.search_text_date_placeholder')
                    "
                    readonly
                    :value="dateSearchText"
                    v-on="on"
                    clearable
                    @click:clear="search.admissionDate = { start: '', end: '' }"
                    :append-icon="
                      datePickerOpen ? 'arrow_drop_up' : 'arrow_drop_down'
                    "
                    @blur="checkIfDatePickerOpen('date-picker', 'blur')"
                    @click="checkIfDatePickerOpen('date-picker')"
                    data-vs-input="search-menu-admission"
                  ></v-text-field>
                </template>
                <div id="date-picker">
                  <vc-date-picker
                    class="mx-auto"
                    :locale="locale"
                    :is-inline="true"
                    mode="range"
                    color="indigo"
                    v-model="search.admissionDate"
                    data-vs-datepicker="search-admission-date"
                  >
                  </vc-date-picker>
                </div>
              </v-menu>
            </div>

            <div>
              <p class="text-zt-sm text-zt-primary-200 mt-2 mb-2">
                {{ $t('message.searchComponent.search_text_11') }}
              </p>
              <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="258px"
                min-width="258px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :placeholder="
                      $t('message.searchComponent.search_text_date_placeholder')
                    "
                    readonly
                    :value="departureRangeDate"
                    v-on="on"
                    clearable
                    @click:clear="search.departureDate = { start: '', end: '' }"
                    :append-icon="
                      datePickerOpen ? 'arrow_drop_up' : 'arrow_drop_down'
                    "
                    @blur="checkIfDatePickerOpen('departured-picker', 'blur')"
                    @click="checkIfDatePickerOpen('departured-picker')"
                    data-vs-input="search-menu-departure"
                  ></v-text-field>
                </template>
                <div id="departured-picker">
                  <vc-date-picker
                    class="mx-auto"
                    :locale="locale"
                    :is-inline="true"
                    mode="range"
                    color="indigo"
                    v-model="search.departureDate"
                    data-vs-datepicker="search-departure-date"
                  >
                  </vc-date-picker>
                </div>
              </v-menu>
            </div>

            <p class="text-zt-sm text-zt-primary-200 mt-2 mb-2">
              {{ $t('message.searchComponent.search_text_6') }}
            </p>
            <div>
              <label class="m-checkbox m-checkbox--bold checkbox_secondary">
                <input
                  type="checkbox"
                  v-model="search.aprobador.active"
                  data-vs-checkbox="search-aprobador"
                />
                {{ $t('message.searchComponent.search_text_6_1') }}
                <span></span>
              </label>
            </div>
          </div>
          <div class="text-center pb-3">
            <zt-button
              color="secondary"
              :disabled="!search.ready"
              @click.prevent="searchEmployees(limit, 1, '')"
              data-vs-button="search-employees-list"
              >{{ $t('message.searchComponent.searchfor') }}</zt-button
            >
          </div>
        </form>
      </v-card>
    </div>
    <div class="xs:w-full sm:w-full md:w-3/4">
      <v-card class="mx-3 h-full">
        <div>
          <div class="Header flex">
            <p
              v-if="data.length == 0"
              class="p-5 ml-3 text-zt-xl text-zt-primary-200 font-medium"
            >
              {{ $t('message.searchComponent.employees_list_result') }}
            </p>
            <p
              v-else
              class="p-5 ml-3 text-zt-xl text-zt-primary-200 font-medium"
            >
              {{ $t('message.searchComponent.employee_result') }}
            </p>
            <div v-if="data.length > 0" class="flex justify-end items-center">
              <p class="text-gray-800 font__lighter">
                {{ $t('message.searchComponent.download.text_filter_by_page') }}
              </p>
              <div class="mr-12">
                <v-select
                  class="w-32 ml-4"
                  v-model="limit"
                  :items="optionLimit"
                  @change="reloadTableCountLimit"
                  data-vs-select="search-limit-table"
                ></v-select>
              </div>
              <div v-if="search.userIds.length > 0">
                <div class="mr-10">
                  <button
                    type="reset"
                    @click="activeOnb(search.userIds)"
                    :disabled="isActiveMode"
                    class="btn btn-primary btn-activar-usr "
                    data-vs-button="search-active-ob"
                  >
                    {{ $t('message.employee_activate_selection') }}
                  </button>
                </div>
              </div>

              <div class="mr-8" v-if="search.userIds.length == 0">
                <a
                  @click="exportUserList()"
                  class=" text-gray-600 font__lighter"
                  style="width:auto;"
                  v-if="!isExportingLoader"
                  data-vs-input="search-donwload"
                >
                  {{
                    $t(
                      'message.searchComponent.download.employee_export_results'
                    )
                  }}
                  <svg
                    class="inline-block mb-2"
                    width="35"
                    height="20"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.5 6C0.5 5.72386 0.723858 5.5 1 5.5H4C4.27614 5.5 4.5 5.72386 4.5 6C4.5 6.27614 4.27614 6.5 4 6.5H1.5V16.5H18.5V10C18.5 9.72386 18.7239 9.5 19 9.5C19.2761 9.5 19.5 9.72386 19.5 10V17C19.5 17.2761 19.2761 17.5 19 17.5H1C0.723858 17.5 0.5 17.2761 0.5 17V6Z"
                      fill="#004250"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.6464 0.646447C14.8417 0.451184 15.1583 0.451184 15.3536 0.646447L19.3536 4.64645C19.5488 4.84171 19.5488 5.15829 19.3536 5.35355L15.3536 9.35355C15.1583 9.54882 14.8417 9.54882 14.6464 9.35355C14.4512 9.15829 14.4512 8.84171 14.6464 8.64645L18.2929 5L14.6464 1.35355C14.4512 1.15829 14.4512 0.841709 14.6464 0.646447Z"
                      fill="#004250"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.81802 5.81802C8.66193 4.97411 9.80653 4.5 11 4.5H19C19.2761 4.5 19.5 4.72386 19.5 5C19.5 5.27614 19.2761 5.5 19 5.5H11C10.0717 5.5 9.1815 5.86875 8.52513 6.52513C7.86875 7.1815 7.5 8.07174 7.5 9V11C7.5 11.2761 7.27614 11.5 7 11.5C6.72386 11.5 6.5 11.2761 6.5 11V9C6.5 7.80653 6.97411 6.66193 7.81802 5.81802Z"
                      fill="#004250"
                    />
                  </svg>
                </a>
                <div v-if="isExportingLoader">
                  <p class="text-gray-600 font__lighter">
                    {{
                      $t(
                        'message.searchComponent.download.employee_exporting_results'
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="px-4 relative">
            <div
              v-if="loadingBar"
              class="absolute d-flex justify-center align-center w-full h-64 "
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div
              class="flex flex-col justify-center text-center mt-12 "
              v-show="notFound"
            >
              <div class="desert self-center"></div>
              <div class="mt-2 text-center ">
                <h4 class="text-zt-primary-200">
                  {{
                    $t(
                      'message.searchComponent.employees_list_search_title_error'
                    )
                  }}
                </h4>
                <p
                  class="mt-2 pb-4 px-20 text-gray-700 opacity-75 font__lighter"
                >
                  {{
                    $t(
                      'message.searchComponent.employees_list_search_desc_error'
                    )
                  }}
                </p>
              </div>
            </div>
            <div v-if="data.length > 0">
              <table class="w-full mt-2">
                <thead>
                  <tr class="h-12 text-left ">
                    <th class="hidden sm:block md:block lg:block xl:block"></th>
                    <th
                      class="text-left"
                      @click.self="searchEmployees(limit, 1, 'name')"
                      data-vs-button="search-name-sort"
                    >
                      {{
                        $t('message.searchComponent.head_text_table_search_1')
                      }}
                    </th>
                    <th
                      @click="searchEmployees(limit, 1, 'mail')"
                      data-vs-button="search-mail-sort"
                    >
                      {{
                        $t('message.searchComponent.head_text_table_search_2')
                      }}
                    </th>
                    <th
                      @click="searchEmployees(limit, 1, 'document')"
                      data-vs-button="search-document-sort"
                    >
                      {{
                        $t('message.searchComponent.head_text_table_search_3')
                      }}
                    </th>
                    <th
                      @click="searchEmployees(limit, 1, 'file')"
                      data-vs-button="search-file-sort"
                    >
                      {{
                        $t('message.searchComponent.head_text_table_search_4')
                      }}
                    </th>
                    <th>
                      {{
                        $t('message.searchComponent.head_text_table_search_6')
                      }}
                    </th>
                    <th style="padding-left: 2%; width: 10em;">
                      {{
                        $t('message.searchComponent.head_text_table_search_5')
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(user, index) in data"
                    :key="user.id"
                    class="ob-true"
                    :class="{ 'cursor-pointer': isManager }"
                    data-vs-button="employee-view"
                    @click="employeeView(user.id)"
                  >
                    <td class="hidden sm:block md:block lg:block xl:block">
                      <div v-if="user.avatar">
                        <zt-avatar :src="user.avatar" size="48px" />
                      </div>
                      <div v-else>
                        <zt-avatar
                          :text="
                            `${user.nombre
                              .charAt(0)
                              .toUpperCase()} ${user.apellido
                              .charAt(0)
                              .toUpperCase()}`
                          "
                          size="48px"
                        />
                      </div>
                    </td>
                    <td>
                      <div class="name_emp">
                        {{ `${user.nombre} ${user.apellido}` }}
                      </div>
                    </td>
                    <td class="truncate">{{ user.mail ? user.mail : '-' }}</td>
                    <td>{{ user.dni ? user.dni : '-' }}</td>
                    <td>{{ user.numero_legajo ? user.numero_legajo : '-' }}</td>
                    <td>
                      {{
                        user.fecha_contratacion ? user.fecha_contratacion : '-'
                      }}
                    </td>
                    <td>
                      <zt-tooltip
                        :text="
                          $t(
                            'message.searchComponent.search_reset_pass_tooltip'
                          )
                        "
                        color="secondary"
                        position="top"
                      >
                        <div
                          class="reset-password"
                          @click="
                            getResetPassword(user.id, user.mail, user.usuario),
                              (showResetPass = !showResetPass)
                          "
                          :data-vs-button="`reset-pass-${index}`"
                        >
                          <a href="#"
                            ><span class="text-5xl icon-ResetPass"></span
                          ></a>
                        </div>
                      </zt-tooltip>
                      <div class="state-hide">
                        <div v-if="user.estado_empresa == '0'">
                          <div class="circle_danger"></div>
                          Inactivo
                        </div>
                        <div v-if="user.estado_empresa == '1'">
                          <div class="circle_success"></div>
                          Activo
                        </div>
                        <div v-if="user.estado_empresa == '2'">
                          <div class="chart w-12 ml-4">
                            <pie-chart
                              :ratio="parseInt(user.porc_estado)"
                              :percent="42"
                              :stroke-width="1"
                              :label="user.porc_estado + '%'"
                              label-small=""
                              :color="
                                buildColorGraph(user.porc_estado, 'color')
                              "
                              :opacity="0.7"
                            />
                          </div>
                        </div>
                        <div v-if="user.estado_empresa == '3'">
                          <div class="circle_danger"></div>
                          Inactivo
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="flex justify-between mt-2">
                <div class="ml-3 flex">
                  <p class="font__lighter">Total &nbsp;</p>
                  <strong class="text-gray-700"> {{ total }}</strong>
                </div>
                <div class="mr-20 pb-6" v-show="total > this.limit">
                  <paginate
                    v-model="page"
                    :page-count="totalPage"
                    :click-handler="reloadTable"
                    :prev-link-class="'icon-LeftChevron'"
                    :next-link-class="'icon-RightChevron'"
                    :prev-text="''"
                    :next-text="''"
                    :page-range="3"
                    :margin-pages="2"
                    :container-class="'pagination'"
                    :page-class="' paginate_button page-item'"
                    :page-link-class="'page-link'"
                  >
                    <span slot="breakViewContent">
                      <svg width="8" height="4" viewBox="0 0 16 4">
                        I
                        <circle fill="#999999" cx="2" cy="2" r="2" />
                        <circle fill="#999999" cx="8" cy="2" r="2" />
                        <circle fill="#999999" cx="14" cy="2" r="2" />
                      </svg>
                    </span>
                  </paginate>
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex flex-col justify-center text-center mt-12 "
              v-show="!notFound"
            >
              <div>
                <graphic-base height="40%" width="16%" viewBox="0 0 166 207">
                  <empty-Search />
                </graphic-base>
              </div>
              <div class="mt-10 text-center ">
                <h4 class=" text-zt-primary-200">
                  {{
                    $t('message.searchComponent.employees_list_search_title')
                  }}
                </h4>
                <p
                  class="mt-2 pb-4 px-20 text-gray-700 opacity-75 font__lighter"
                >
                  {{ $t('message.searchComponent.employees_list_search_desc') }}
                </p>
              </div>
            </div>
            <zt-modal :active="showResetPass" @close="showResetPass = false">
              <div slot="modal-header">
                <div class="p-4">
                  <p class="text-zt-xl">
                    {{
                      $t('message.searchComponent.search_reset_pass_tooltip')
                    }}
                  </p>
                </div>
              </div>
              <div class="p-4">
                <p class="text-gray-600">
                  {{
                    $t(
                      'message.searchComponent.employees_list_modal_reset_subtitle'
                    )
                  }}
                </p>
                <form
                  name="resetPass"
                  action
                  @submit.prevent="passwordChange()"
                  data-vs-form="'reset-pass'"
                >
                  <div class="email-pass-container">
                    <ValidationProvider
                      rules="required|email"
                      v-slot="{ errors }"
                      name="Email"
                      ref="mailValidator"
                    >
                      <zt-input
                        class="mt-4"
                        name="mail"
                        :label="
                          $t('message.searchComponent.ei_titleList_text_2_2')
                        "
                        v-model="resetPass.mail"
                        type="email"
                        data-vs-input="reset-pass-email"
                      />
                      <span class="redErrorText">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div slot="modal-footer">
                    <div
                      class="zt-modal-footer flex justify-center lg:justify-end items-center p-4"
                    >
                      <zt-button
                        type="submit"
                        class="mr-1"
                        data-vs-input="reset-pass-send"
                        >{{
                          $t('message.searchComponent.login_send')
                        }}</zt-button
                      >
                      <zt-button
                        class="ml-1"
                        outlined
                        @click.prevent="showResetPass = false"
                        data-vs-input="reset-pass-cancel"
                        >{{ $t('message.searchComponent.cancel') }}</zt-button
                      >
                    </div>
                  </div>
                </form>
              </div>
            </zt-modal>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VCalendar from 'v-calendar'
import Paginate from 'vuejs-paginate'
import PieChart from 'vue-pie-chart/src/PieChart.vue'
import User from '../../../apiClient/Users'
import Search from '../../../apiClient/Search'
import Multiselect from 'vue-multiselect'
import graphicBase from '../../../components/commons/Illustrations/graphicBase'
import emptySearch from '../../../components/commons/Illustrations/graphicSVG/graphicEmptySearch'
import { mapGetters } from 'vuex'
import { sortBy } from 'lodash'
import moment from 'moment'
import Company from "../../../apiClient/Company";
import { ValidationProvider } from 'vee-validate';

Vue.use(VCalendar, {
  componentPrefix: 'vc'
})

export default {
  name: 'search',
  components: {
    Multiselect,
    Paginate,
    PieChart,
    graphicBase,
    emptySearch,
    ValidationProvider
  },
  data() {
    return {
      isManager: false,
      selectedItem: {},
      optionLimit: [10, 25, 50],
      isExportingLoader: false,
      data: [],
      notFound: false,
      total: 0,
      totalPage: 0,
      advanced_search: false,
      loadingBar: false,
      isLoading: false,
      limit: 25,
      search: {
        user: '',
        legajo: '',
        sector: {
          value: this.$t('message.searchComponent.advanceSearch.all_sector'),
          data: []
        },
        locacion: {
          value: this.$t('message.searchComponent.advanceSearch.all_locacion'),
          data: []
        },
        cargo: {
          value: '',
          data: []
        },
        report: {
          value: '',
          datos: []
        },
        sectorLocacion: {
          value: this.$t('message.searchComponent.search_text_select_locacion'),
          data: [],
          valueArr: [],
          valueClosedArr: [],
          formValue: '',
          locationChipsArr: []
        },
        estatus: {
          activo: 1,
          onBoarding: 2,
          inactivo: 3
        },
        checkedEstatus: [],
        empleado: {
          value: 1
        },
        rrhh: {
          value: 2
        },
        esRRRHHSector: false,
        aprobador: {
          active: false,
          value: 1
        },
        primer_login: {
          active: false,
          value: 0
        },

        admissionDate: {
          start: '',
          end: ''
        },
        checkedTipoPerfil: [],
        currentSort: 'name',
        currentSortDir: 1,
        selected: [],
        allSelected: false,
        userIds: [],
        totaluserIdsOnboarding:[],
        departureDate: {
          start: '',
          end: ''
        },
        ready: false
      },
      resetPass: {
        id: '',
        user: '',
        mail: ''
      },
      mail: '',
      paginatePage: this.page,
      data_list: [],
      show: false,
      showResetPass: false,
      page: 1,
      paramsPositionReport: '',
      bufferFree: true,
      datePickerOpen: false
    }
  },
  created() {
    this.isManager = this.$store.state.user.perfiles.some(objeto => objeto.id_perfil_tipo === 8);
    this.ob = new Search()
    this.userClient = new User()
    this.companyUser = new Company()
    this.getIdCompany()
    this.searchCargo()
    this.searchSector()
    this.searchLocacion()
  },
  computed: {
    ...mapGetters({
      locale: 'getLocaleForDatepicker',
      getprofile: 'getProfile'
    }),
    dateSearchText() {
      let dateSearchText = ''

      if (this.search.admissionDate && this.search.admissionDate.start !== '') {
        let admissionDateStart = moment(this.search.admissionDate.start)
        let admissionDateEnd = moment(this.search.admissionDate.end)

        dateSearchText = `${admissionDateStart.format(
          'DD/MM/YYYY'
        )} - ${admissionDateEnd.format('DD/MM/YYYY')}`
      }

      return dateSearchText
    },

    hiring_date_from() {
      let hdf = ''
      if (this.search.admissionDate && this.search.admissionDate.start !== '') {
        let admissionDateStart = moment(this.search.admissionDate.start)

        hdf = `${admissionDateStart.format('YYYY-MM-DD')}`
      }
      return hdf
    },

    hiring_date_until() {
      let hdu = ''
      if (this.search.admissionDate.end !== '') {
        let admissionDateEnd = moment(this.search.admissionDate.end)

        hdu = `${admissionDateEnd.format('YYYY-MM-DD')}`
      }
      return hdu
    },

    departureRangeDate() {
      if (!this.search.departureDate) {
        return ''
      }

      if (
          this.search.departureDate &&
          this.search.departureDate.start &&
          this.search.departureDate.end
      ) {
        const start = moment(this.search.departureDate.start)
        const end = moment(this.search.departureDate.end)

        this.search.departureDate.params = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]

        return `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`
      } else {
        return ''
      }
    }
  },
  methods: {
    checkIfDatePickerOpen(id, blur) {
      setTimeout(() => {
        let datepicker = document.getElementById(id)
        // return datepicker
        if (blur) {
          this.datePickerOpen = false
        } else {
          this.datePickerOpen = datepicker.parentElement.classList.contains(
              'menuable__content__active'
          )
        }
      }, 200)
    },
    searchCargo(){
      this.search.cargo.value = [];
      this.userClient.getPosition()
          .then((res) =>{
            this.search.cargo.data = res.data.results.data[0];
          })
          .catch((error) =>{
            console.log(error);
          });
    },
    searchSector(){
      this.userClient.getSector()
          .then((res) =>{
            this.search.sector.data = res.data.results.data;
            this.search.sector.data.unshift(this.$t("message.searchComponent.advanceSearch.all_sector"));
          })
          .catch((error) =>{
            console.log(error)
          });
    },
    searchLocacion(){
      this.userClient.getLocacion()
          .then((res) =>{
            this.search.locacion.data = res.data.results.data;
            this.search.locacion.data.unshift(this.$t("message.searchComponent.advanceSearch.all_locacion"));
          })
          .catch((error) =>{
            console.log(error)
          });
    },
    reloadTable(page) {
      this.searchEmployees(this.limit, page, this.search.currentSort)
    },
    reloadTableCountLimit() {
      this.searchEmployees(this.limit, 1, this.search.currentSort);
    },
    getResetPassword(userId,userMail,userUser) {
      this.resetPass.id = userId;
      this.resetPass.user = userUser;
      userMail== null ? this.resetPass.mail='': this.resetPass.mail= userMail;
      this.userClient.getprofileById(userId)
          .then(result =>{
            if(result.status == 200){
              console.log(result.data.results.data[0].aplicacion.dominio);
            }
          })
          .catch(error =>{
            console.log(error);
          })
    },
    async exportUserList(){
      this.isExportingLoader = true;
      var params = this.buildFilter();
      params.append("download","1");
      await this.ob.searchEmployees(this.total,this.page,params).then(response => {
        if(response.status === 200) {
          let request = response.request;
          let disposition = request.getResponseHeader('content-disposition');
          let matches = /"([^"]*)"/.exec(disposition);
          let filename = (matches != null && matches[1] ? matches[1] : 'empleados.xls');
          var blob = new Blob([request.response], {type:'application/vnd.ms-excel;charset=utf-8'});
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isExportingLoader = false;
        }
      }).catch(e => {
        this.isExportingLoader = false;
      })
    },
    searchEmployees(limit,page,sort) {
      var params = this.buildFilter();
      this.loadingBar = true;
      this.ob.searchEmployees(limit,page,params)
          .then((res) =>{
            if(res.status === 200){
              let totalPageInt = Math.trunc(res.data.pagination.total/res.data.pagination.limit);
              this.notFound = false;
              this.loadingBar = false;
              this.data = res.data.results.data;
              this.total = res.data.pagination.total;
              this.limit = res.data.pagination.limit;
              this.page = res.data.pagination.offset;
              this.totalPage = (res.data.pagination.total % res.data.pagination.limit) > 0 ? totalPageInt + 1 : totalPageInt;
            }
          })
          .catch(e =>{
            this.loadingBar = false;
            this.data = '';
            this.notFound = true;
          })
    },
    buildFilter() {
      var params = new URLSearchParams();
      if (this.search.user.length !=0) {params.append('principal',(this.search.user));}
      if (this.search.legajo.length !=0) {params.append('legajo', (this.search.legajo));}
      if (this.search.checkedEstatus.length !=0) {params.append('estado', this.search.checkedEstatus);}
      if (this.search.checkedTipoPerfil.length !=0) {params.append('perfil', this.search.checkedTipoPerfil);}
      if (this.search.sector.length !=0 && this.search.sector.value != this.$t("message.searchComponent.advanceSearch.all_sector"))
      {params.append('sector', (this.search.sector.value));}
      if (this.search.locacion.length !=0 && this.search.locacion.value != this.$t("message.searchComponent.advanceSearch.all_locacion")) {params.append('locacion', (this.search.locacion.value));}
      if (this.search.cargo.length !=0 && this.search.cargo.value != null && this.search.cargo.value != '') {params.append('cargo', (this.search.cargo.value));}
      if (this.search.report.length !=0 && this.search.report.value != null && this.search.report.value != '') {params.append('reporta', (this.search.report.value.cuil));}
      if (this.search.sectorLocacion.formValue != "" ) {
        params.append('sectorLocacion', this.search.sectorLocacion.formValue);
      }
      else if (this.search.sectorLocacion.data.length > 0 ){
        var res =[];
        for (var i = 0; i < this.search.sectorLocacion.valueClosedArr.length; i++) {
          res.push(this.search.sectorLocacion.valueClosedArr[i].id);
        }
        params.append('sectorLocacion', (res.join(",")));
      }
      if (this.search.aprobador.active == true) {params.append('aprobador',this.search.aprobador.value)}
      if (this.search.primer_login.active == true) {params.append('primerlogin',this.search.primer_login.value);}
      if (this.search.currentSort) {params.append('orderfield',this.search.currentSort);}
      if (this.search.currentSortDir) {params.append('ordersort',this.search.currentSortDir);}

      if (this.hiring_date_from !== '' && this.hiring_date_until !== '') {
        params.append('hiring_date_from', this.hiring_date_from)
      }
      if (this.hiring_date_from !== '' && this.hiring_date_until !== '') {
        params.append('hiring_date_until', this.hiring_date_until)
      }
      if (this.search.departureDate && this.search.departureDate.start && this.search.departureDate.end) {
        params.append('fechadesvincdesde', this.search.departureDate.params[0])
        params.append('fechadesvinchasta', this.search.departureDate.params[1])
      }
      return params;
    },
    buildingFilter(value){
      var params = new URLSearchParams();
      if (value.length !=0) {params.append('principal',(value));}
      return params;
    },
    buildFilterForReport(value){
      var params = new URLSearchParams();
      if (value.length !=0) {params.append('search',(value));}
      return params;
    },
    searchingEmployees(value) {
      this.search.report.datos = []
      if (value.length > 2 && this.bufferFree) {
        this.paramsPositionReport = this.buildFilterForReport(value)
        this.searchReport_to()
      }
    },
    searchReport_to() {
      this.bufferFree = false;
      this.isLoading = true;
      this.ob.SearchEmployeesToReport(this.paramsPositionReport)
          .then((res) => {
            if (res.status === 200) {
              this.isLoading = false
              let auxData = res.data;
              auxData.forEach(element => {
                let reporter = {
                  name: '',
                  cuil: '',
                }
                reporter.name = element.nombre + ' ' + element.apellido;
                reporter.cuil = element.cuil;
                this.search.report.datos.push(reporter);
                this.bufferFree = true;
              });
            }
          })
          .catch((error) => {
            this.isLoading = false
            this.search.report.datos = [];
            this.bufferFree = true;
          })
    },
    async getIdCompany() {
      
            await this.searchSectorLocacion()
            this.companyId = this.getprofile.empresa.id;
            this.activeId = this.getprofile.id;
         
    },
    searchSectorLocacion(){
      return new Promise( (resolve, reject) => {
        this.companyUser.getSectorAndLocation()
          .then((res) => {
            let dataArr = res.data.data.map(item => {
              item.id = item.id.replace(/,/g, '&#44;');
              return item;
            });
            if(dataArr.length > 0){
              this.search.esRRRHHSector = true
            }
            this.search.sectorLocacion.data = dataArr;
            this.search.sectorLocacion.valueArr =  [];
            this.search.sectorLocacion.valueClosedArr =  [];
            this.search.sectorLocacion.valueArr =  this.search.sectorLocacion.formValue.split(",");
            for (let i = 0; i < dataArr.length; i++){
              if (typeof dataArr[i].id === 'string'){
                let isSelected = this.search.sectorLocacion.valueArr.includes(dataArr[i].id) ? true : false;
                this.search.sectorLocacion.valueClosedArr.push({
                  id: dataArr[i].id,
                  value: dataArr[i].name,
                  selected: isSelected,
                });
              }
            }
            this.search.sectorLocacion.valueClosedArr = sortBy(this.search.sectorLocacion.valueClosedArr, ['value'])
            this.search.ready = true
            resolve(true);
          })
          .catch((error) => {
            reject(false);
          }).finally(()=>{
            const user = this.getprofile
            user.perfiles.forEach(profile => {
              if (profile.id_perfil_tipo === 8) {
                this.search.ready = true
              }
            });
          });
      });

    },

    closeChip(item, index) {
      this.search.sectorLocacion.locationChipsArr[index].selected = false
      this.search.sectorLocacion.locationChipsArr.forEach(element => {
        if (element.id === item.id) {
          let elementIndex = this.search.sectorLocacion.locationChipsArr.indexOf(
            element
          )
          this.search.sectorLocacion.locationChipsArr.splice(elementIndex, 1)
        }
      })
      this.search.sectorLocacion.valueClosedArr.push(item)
      this.search.sectorLocacion.valueClosedArr = sortBy(
        this.search.sectorLocacion.valueClosedArr,
        ['value']
      )
      this.updateSearchSectLocValue()
    },
    openChip(item) {
      this.search.sectorLocacion.valueClosedArr.forEach((element, index) => {
        if (element.id === item.id) {
          this.search.sectorLocacion.valueClosedArr.splice(index, 1)
        }
      })
      this.selectedItem = {}
      this.search.sectorLocacion.locationChipsArr.push(item)
      this.$refs.selectFilter.blur()
      this.updateSearchSectLocValue()
    },
    updateSearchSectLocValue(){
      this.search.sectorLocacion.formValue = "";
      let res = [];
      for (let i = 0; i < this.search.sectorLocacion.locationChipsArr.length; i++){
        if (this.search.sectorLocacion.locationChipsArr[i])
          res.push(this.search.sectorLocacion.locationChipsArr[i].id);
      }
      this.search.sectorLocacion.formValue = res.join(",");
    },
   passwordChange() {
     this.$refs.mailValidator.validate().then(result => {
        if (result) {
          this.userClient.changeMailResetPass(this.resetPass.id, this.resetPass.mail)
              .then(result => {
                if (result.status == 200) {
                  let params = [];
                  params.push(this.resetPass.user);
                  params.push(this.resetPass.mail);
                  this.userClient.resetpass("request",params)
                      .then(result => {
                        if (result.status == 200) {
                          this.$swal({
                            type: 'success',
                            title: `${this.$t("message.searchComponent.alerts.modal_reset_pass_correct")}`,
                            showConfirmButton: true,
                            confirmButtonText: `${this.$t("message.searchComponent.alerts.button_confirm")}`
                          }).then(() => {
                            this.reloadTable(this.page)
                            this.showResetPass = false
                          });
                        }
                      })
                      .catch(error => {
                        this.$swal({
                          type: 'error',
                          title: `${this.$t("message.searchComponent.alerts.modal_reset_pass_incorrect")}`,
                          showConfirmButton: true,
                          confirmButtonText: `${this.$t("message.searchComponent.alerts.button_confirm")}`
                        }).then(() => {
                          this.reloadTable(this.page)
                          this.showResetPass = false
                        });
                      });
                }
              })
              .catch(error => {
                this.$swal({
                  type: 'error',
                  title: `${this.$t("message.searchComponent.alerts.modal_reset_pass_incorrect_change")}`,
                  showConfirmButton: true,
                  confirmButtonText: `${this.$t("message.searchComponent.alerts.button_confirm")}`
                }).then(() => {
                  this.reloadTable(this.page)
                  this.showResetPass = false
                });
              });
        }
     })
    },
    buildColorGraph(percentData, type) {
      let percent = Math.round(percentData) / 100
      let item
      if (percent === 0) {
        type === 'color'
          ? (item = '#ccc')
          : (item = this.$t('message.ob_not_started').toString())
      } else if (percent > 0 && percent <= 0.2) {
        type === 'color'
          ? (item = '#F16B6C')
          : (item = item = this.$t('message.ob_not_completed').toString())
      } else if (percent > 0.2 && percent <= 0.99) {
        type === 'color'
          ? (item = '#FCAB10')
          : (item = this.$t('message.ob_not_completed').toString())
      } else if (percent === 1) {
        type === 'color'
          ? (item = '#54CAA6')
          : (item = this.$t('message.ob_completed').toString())
      }
      return item
    },
    clearReport() {
      this.search.report.value = []
    },
    clearPosition() {
      this.search.cargo.value = []
    },
    employeeView(doc) {
      const tdElement = event.target.closest('td');
      const hasResetPasswordClass = tdElement.querySelector('div.reset-password') !== null;
  
        if (this.isManager && !hasResetPasswordClass) this.$router.push({ name: "infoEmployee", params: { id: doc} });
      }
  }
}
</script>

<style lang="scss" scoped>
@import './search.scss';
</style>
